import "./shipping-signature-button.scss";

import { useRootContext } from "@client/context/RootContext";

export default function ShippingSignatureButton() {
	const { vendorStore } = useRootContext();

	return (
		<div className="shipping-signature-button-container">
			<button
				className="shipping-signature-button"
				onClick={() =>
					vendorStore.PickupsOperations.shipping_signature.show_modal()
				}
			>
				שילוח
			</button>
		</div>
	);
}
